import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogOverlay,
  DialogPortal,
  DialogTitle,
  ScrollArea,
} from "@devhop/ui";
import { useCreatePrivateLessonBooking } from "../api/queries";
import { BookingCreateForm } from "./BookingCreateForm";

type CreatePrivateBookingDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  initialDate?: string;
  initialStartTime?: string;
  initialEndTime?: string;
  onSuccess?: () => void;
};

export function CreatePrivateBookingDialog({
  open,
  onOpenChange,
  initialDate,
  initialStartTime,
  initialEndTime,
  onSuccess,
}: CreatePrivateBookingDialogProps) {
  const createBooking = useCreatePrivateLessonBooking();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogPortal>
        <DialogOverlay />
        <DialogContent
          className="!max-w-[min(95vw,1200px)] max-h-[90vh] overflow-hidden p-0"
          showCloseButton
        >
          <DialogHeader className="border-b px-6 py-4">
            <DialogTitle>ຈອງຮຽນສ່ວນຕົວ</DialogTitle>
          </DialogHeader>
          <ScrollArea className="max-h-[calc(90vh-4rem)] overflow-auto px-6 pb-6">
            <BookingCreateForm
              key={
                open
                  ? `${initialDate ?? ""}-${initialStartTime ?? ""}-${initialEndTime ?? ""}`
                  : "closed"
              }
              initialDate={initialDate}
              initialStartTime={initialStartTime}
              initialEndTime={initialEndTime}
              onSubmit={async (vals) => {
                try {
                  await createBooking.mutateAsync(vals);
                  onSuccess?.();
                  onOpenChange(false);
                } catch {
                  // Error handled by mutation
                }
              }}
              submitting={createBooking.isPending}
            />
          </ScrollArea>
        </DialogContent>
      </DialogPortal>
    </Dialog>
  );
}
